import { NumericTextBox } from '@progress/kendo-react-inputs';
import MarkerText from '../../../../components/inputs/MarkerText';
import { useSettingNumericValue } from '../../../home/hooks/settings';
import { useSearchContext } from '../../context/SettingsSearchContext';
import { FlashMarkerPreview } from './FlashMarkerPreview';

export function SettingsMapFlashMarkerDuration() {
    const context = useSearchContext();
    const value = useSettingNumericValue('mapFlashMarkerDurationSeconds');
    return (
        <div className="px-3 d-flex align-items-center justify-content-between">
            <div className="d-flex align-items-center gap-2">
                <MarkerText highlight={context.term}>Time to show map location marker</MarkerText>
                <FlashMarkerPreview />
            </div>
            <div>
                <NumericTextBox format={'0 seconds'} min={2} max={60} {...value} />
            </div>
        </div>
    );
}
